module.exports = __webpack_public_path__ + "static/media/Location_Book-Page9.256cdec8.png";